import { apiClient } from './client';
export const authConnectionsApi = {
    // Create a new auth connection
    createConnection: (clientCompanyId, authOrgId, payload, signal) => {
        return apiClient.post(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections`, payload, { signal });
    },
    // List all connections for an auth organization
    listConnections: (clientCompanyId, authOrgId, signal) => {
        return apiClient.get(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections`, { signal });
    },
    // Get a specific connection
    getConnection: (clientCompanyId, authOrgId, connectionId, signal) => {
        return apiClient.get(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}`, { signal });
    },
    // Enable a connection
    enableConnection: (clientCompanyId, authOrgId, connectionId, signal) => {
        return apiClient.put(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}/Enable`, {}, { signal });
    },
    // Disable a connection
    disableConnection: (clientCompanyId, authOrgId, connectionId, signal) => {
        return apiClient.put(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}/Disable`, {}, { signal });
    },
    // Delete a connection
    deleteConnection: (clientCompanyId, authOrgId, connectionId, signal) => {
        return apiClient.delete(`/api/ClientCompanies/${clientCompanyId}/AuthOrganizations/${authOrgId}/Connections/${connectionId}`, { signal });
    }
};
